import { Case } from "@componentsShared/Conditional/Case";
import { Default } from "@componentsShared/Conditional/Default";
/**
 * Switch component with Case/Default pattern
 * @example
 * <Switch value={userRole}>
 *   <Case value="admin"><AdminPanel /></Case>
 *   <Case value="user"><UserDashboard /></Case>
 *   <Case value="guest"><GuestView /></Case>
 *   <Default><LoginPrompt /></Default>
 * </Switch>
 */
export var Switch = function Switch(_ref) {
  var value = _ref.value,
    children = _ref.children;
  var childrenArray = Array.isArray(children) ? children : [children];

  // Find matching Case
  var matchingCase = childrenArray.find(function (child) {
    var _child$props;
    return (child === null || child === void 0 ? void 0 : child.type) === Case && (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.value) === value;
  });
  if (matchingCase) {
    return matchingCase;
  }

  // Find Default case
  var defaultCase = childrenArray.find(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === Default;
  });
  return defaultCase || null;
};